export function clampPanelPosition(position, container, panel, padding = 8) {
    const maxX = Math.max(padding, Number(container?.width ?? 0) - Number(panel?.width ?? 0) - padding);
    const maxY = Math.max(padding, Number(container?.height ?? 0) - Number(panel?.height ?? 0) - padding);

    return {
        x: Math.min(Math.max(padding, Number(position?.x ?? padding)), maxX),
        y: Math.min(Math.max(padding, Number(position?.y ?? padding)), maxY),
    };
}

export function draggedPanelPosition(origin, pointerStart, pointerCurrent, container, panel) {
    return clampPanelPosition({
        x: Number(origin?.x ?? 0) + Number(pointerCurrent?.x ?? 0) - Number(pointerStart?.x ?? 0),
        y: Number(origin?.y ?? 0) + Number(pointerCurrent?.y ?? 0) - Number(pointerStart?.y ?? 0),
    }, container, panel);
}

const DEFAULT_PANEL_STATE = Object.freeze({ x: 10, y: 10, minimized: false });

export function parsePanelState(serialized, fallback = null) {
    const initial = fallback ?? DEFAULT_PANEL_STATE;

    try {
        const saved = JSON.parse(serialized);

        return {
            x: Number.isFinite(saved?.x) ? saved.x : initial.x,
            y: Number.isFinite(saved?.y) ? saved.y : initial.y,
            minimized: saved?.minimized === true,
        };
    } catch {
        return { ...initial };
    }
}
